import { FilterType } from '../../../../../../types/types';
import { formatStaticDateTime } from '../../../utils/formatStaticDateTime';
import { formatStaticTime } from '../../../utils/formatStaticTime';

export const getDisplayValue = (
  value: string | null,
  type?: FilterType
): string | null => {
  if (type === 'date' || type === 'dateTime')
    return formatStaticDateTime(value);
  if (type === 'time') return formatStaticTime(value);
  return value;
};
